import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header1 from '../components/Header1'
import Hero1 from '../components/Hero1'
import Footer from '../components/Footer'
import Flipbox from '../components/Flipbox'
import Cta from '../components/Cta'
import AboutSection from '../components/AboutSection'
import SolutionSection from '../components/SolutionSection'
import OurProcess from '../components/OurProcess'
import ProspectIntelligence from '../components/ProspectIntelligence'
import ProspectFlipbox from '../components/ProspectFlipbox'
// import ClientSection from '../components/ClientSection'
import BrandSection from '../components/BrandSection';
import ClientComponent from '../components/ClientComponent';

// import BenefitsProspectIntelligence from '../components/BenefitsProspectIntelligence'



export default function Home() {
  return (
    <div>
       <Helmet>
        {typeof window !== 'undefined' && (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ProPlus Data",
        "url": "https://proplusdata.co",
        "logo": "https://proplusdata.co/logo.png",
        "sameAs": [
          "https://www.linkedin.com/company/proplusdata",
          "https://clutch.co/profile/proplus-data"
        ],
        "description": "ProPlus Data delivers B2B contact data, intent data, technographics, and buyer persona insights to help companies improve targeting and accelerate growth."
      })
    }}
  />
)}

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "url": "https://proplusdata.co",
              "name": "ProPlus Data",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://proplusdata.co/?s={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }
          `}
        </script>
      <title>ProPlus Data | B2B Data Solutions | Intent & Buying Signals</title>
    <meta name="description" content="Identify in-market and renewal-ready accounts with verified B2B contacts, intent, and technographic data to help sales and marketing teams drive smarter outreach and stronger pipeline."/>
   <meta name="keywords" content="Intent data, technographics, Next Tech Purchase®, predictive analytics, GTM strategy, B2B data intelligence, ABM targeting, data-driven marketing, sales enablement, global B2B solutions"/>
    <link rel="canonical" href="https://proplusdata.co/"/>
   <meta property="og:url" content="https://proplusdata.co/" />
   <meta property="og:type" content="website" />
   <meta property="og:title" content="ProPlus Data | B2B Data Solutions| Next Tech Purchase®" />
   <meta property="og:description"
       content="Explore our B2B data solutions including contact data, intent signals, technographics, and more to drive better marketing and sales results." />
      </Helmet>
      <Header1/>
       <Hero1/> 
       <Flipbox/>
       {/* <ClientSection/>  */}
       <ClientComponent/>
       <Cta/>
       <AboutSection/>
       <ProspectIntelligence/>
       <ProspectFlipbox/>
       <SolutionSection/>
       <OurProcess/>
       <BrandSection/>
        {/* <BenefitsProspectIntelligence/>  */}
      <Footer/>
       
       
       <div className="btnplaybook-sm">
  <a href="https://7772074d.flowpaper.com/ThePrecisionABMPlaybookbyProPlusData/" target="_blank" rel="noreferrer">
    <img
      src="/assets/images/icon/abm-playbook.svg"
      alt="Playbook"
      className="playbook-icon"
    />
  </a>
</div> 
      <div class="btnwhatsapp-sm">
        <a target="_blank" rel="noreferrer" href="https://wa.me/+919112110691"><i class="fa fa-whatsapp"></i></a>
    </div>
    </div>
  )
}
